import React from 'react';
import { MagazineTitleText } from '../styles';
var MagazineTitle = function (_a) {
    var post = _a.post;
    return React.createElement(MagazineTitleText, null, post.text);
};
export default MagazineTitle;
//# sourceMappingURL=MagazineTitle.js.mapimport React from 'react';
import { MagazineTitleText } from '../styles';
var MagazineTitle = function (_a) {
    var post = _a.post;
    return React.createElement(MagazineTitleText, null, post.text);
};
export default MagazineTitle;
//# sourceMappingURL=MagazineTitle.js.map